import { StandardEvents, CartLinesUpdateEvent } from '@shopify/events';

// Keep the store's existing custom product sections connected to Tinker's
// promise-based events. Native components continue to own their mutations.
const forwarded = new WeakSet();
const emitLegacy = (target, name, detail) => {
  const event = new CustomEvent(name, { bubbles: true, detail });
  forwarded.add(event);
  (target?.isConnected ? target : document).dispatchEvent(event);
};

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (forwarded.has(event)) return;
  event.promise?.then(({ cart, detail }) => {
    emitLegacy(event.target, 'cart:update', { resource: cart, data: detail || {} });
  }).catch(() => {});
});

document.addEventListener(StandardEvents.productSelect, (event) => {
  event.promise?.then(({ detail }) => {
    emitLegacy(event.target, 'variant:update', {
      resource: detail?.resource || null,
      sourceId: detail?.sourceId,
      data: { html: detail?.html, productId: detail?.productId, newProduct: detail?.newProduct },
    });
  }).catch(() => {});
});

document.addEventListener('cart:update', (event) => {
  if (forwarded.has(event) || event.detail?.data?.didError) return;
  const resource = event.detail?.resource;
  const detail = event.detail?.data || {};
  const cartPromise = resource && Number.isFinite(resource.item_count) && Array.isArray(resource.items)
    ? Promise.resolve(resource)
    : fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then((response) => { if (!response.ok) throw new Error('Cart refresh failed'); return response.json(); });
  const update = new CartLinesUpdateEvent({
    action: 'update', context: 'cart', lines: [],
    promise: cartPromise.then((cart) => ({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { ...detail, sections: detail.sections || cart.sections },
    })),
  });
  forwarded.add(update);
  document.dispatchEvent(update);
});
